// web/src/constants/colors.js
// Vibana single theme — "Editorial African Futurism", ONYX & GOLD.
// True onyx ground, gold-leaf linework and seams, warm-ivory ink,
// a flash of flame red kept for primary action. Heritage luxury.

export const VIBANA = {
  // Backgrounds — onyx, with subtly lifted layers
  void:         '#0A0908',
  hero:         '#100D0A',
  darkCard:     '#151210',
  darkCardAlt:  '#1E1A14',

  // Text — warm ivory primary, softened muted tones
  snowPrimary:   '#FBF4E6',
  snowSecondary: 'rgba(251,244,230,0.87)',
  snowMuted:     'rgba(251,244,230,0.72)',
  snowFaint:     'rgba(251,244,230,0.40)',
  inkPrimary:    '#FBF4E6',
  inkSecondary:  'rgba(251,244,230,0.87)',
  inkHint:       'rgba(251,244,230,0.40)',
  smokeDark:     'rgba(251,244,230,0.72)',
  smokeHint:     'rgba(251,244,230,0.40)',

  // Light text for photos / dark cards — stays bright for legibility on any image
  lightPrimary:  '#FFFFFF',
  lightSecondary:'rgba(255,255,255,0.90)',
  lightMuted:    'rgba(255,255,255,0.74)',
  lightFaint:    'rgba(255,255,255,0.55)',

  // Borders — gold hairlines on onyx
  border:       'rgba(217,168,59,0.16)',
  borderDark:   'rgba(217,168,59,0.14)',
  borderLight:  'rgba(217,168,59,0.26)',
  borderMid:    'rgba(217,168,59,0.20)',

  // Dark card borders + fills (fills stay neutral ivory to avoid a yellow cast)
  cardBorderSubtle: 'rgba(217,168,59,0.10)',
  cardBorderMid:    'rgba(217,168,59,0.20)',
  cardBgSubtle:     'rgba(251,244,230,0.03)',
  cardBgFaint:      'rgba(251,244,230,0.05)',
  cardBgLight:      'rgba(251,244,230,0.08)',

  // Brand accents — gold leads, flame red kept for action, jade for "free"
  red:          '#E63946',
  gold:         '#E9C061',
  goldDark:     '#C0801F',
  goldBg:       'rgba(233,162,59,0.14)',
  goldBorder:   'rgba(233,162,59,0.28)',
  goldTintDk:   'rgba(233,162,59,0.10)',
  green:        '#12B886',
  teal:         '#12B886',
  tealBg:       'rgba(18,184,134,0.10)',
  tealBorder:   'rgba(18,184,134,0.28)',
  tealDark:     '#0E9268',
  clay:         '#C2673F',
  clayBg:       'rgba(194,103,63,0.14)',
  plum:         '#7A3B54',

  // Editorial light surfaces (for the deliberate cream Tonight anchor)
  ivory:        '#F5EFE3',
  sand:         '#E7DECC',

  // Signature gradients — gold-leaf seam for linework, flame for action buttons
  seam:         'linear-gradient(90deg, #B8860B 0%, #E9A23B 50%, #F3D27A 100%)',
  flameGold:    'linear-gradient(135deg, #E63946 0%, #E9A23B 100%)',

  // Pills
  pillBg:       '#151210',
  pillBorder:   'rgba(217,168,59,0.16)',
  pillText:     'rgba(251,244,230,0.87)',

  // Tonight section — deliberate cream contrast band in the onyx app
  tonightBg:    '#F5EFE3',
  tonightText:  '#1A1613',
  tonightCard:  '#FFFFFF',
  tonightBorder:'#E7DECC',

  // Trending section
  trendingBg:   '#0A0908',
  trendingText: '#FBF4E6',
  trendingCard: '#151210',

  // Cards / surfaces — onyx cards
  card:         '#151210',
  cardShadow:   '0 4px 24px rgba(0,0,0,0.55)',
  cardShadowHover: '0 24px 64px rgba(0,0,0,0.62)',
  surface:      '#151210',
  canvas:       '#0A0908',
  cream:        '#F3ECDF',
  creamDark:    '#E7DECC',
  white:        '#FFFFFF',
  deep:         '#100D0A',
  deepBlack:    '#151210',

  // Glow tokens — gold-dominant ambient, a whisper of flame
  glowRed:      'rgba(230,57,70,0.12)',
  glowGold:     'rgba(217,168,59,0.20)',
  glowTeal:     'rgba(18,184,134,0.10)',

  // Glass surfaces — neutral ivory glass, gold edge
  glassBg:      'rgba(251,244,230,0.06)',
  glassBorder:  'rgba(217,168,59,0.16)',
};

// Backwards-compat: code still imports `DARK`
export const DARK = VIBANA;

export default VIBANA;
